import type { FC } from 'react'
import type { IStorePageContentFields } from 'types/contentful/generated'

import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { PageLayoutSections } from 'views/contentful/components/PageLayoutSections'

import { StoreImageBanner } from './StoreImageBanner'
import { StoreInfoCard, StoreInfoCardTitle } from './StoreInfoCard'

const PageLayoutContainer = styled.div({
  '> *:first-child': {
    marginTop: 0,
  },
  '> *:last-child': {
    marginBottom: 0,
  },
})

export const StoreLatestContent: FC<{ storeContent: IStorePageContentFields }> = ({
  storeContent,
}) => {
  const { t } = useTranslation()

  if (!storeContent.sections?.length) {
    return storeContent.fallbackImage ? (
      <StoreImageBanner image={storeContent.fallbackImage} />
    ) : null
  }

  return (
    <StoreInfoCard>
      <StoreInfoCardTitle>{t('Recent news')}</StoreInfoCardTitle>

      <PageLayoutContainer>
        <PageLayoutSections sections={storeContent.sections} />
      </PageLayoutContainer>
    </StoreInfoCard>
  )
}
